import { render } from "./static-content-delete.vue?vue&type=template&id=8e40ea70"
import script from "./static-content-delete.vue?vue&type=script&lang=js"
export * from "./static-content-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__